export default __webpack_public_path__ + "static/media/mdas.2381d345.svg";